import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import { ImageFromField } from '@uncinc/react-drupal-core';

import {
  NODE_TYPE_FRONT_PAGE,
  NODE_TYPE_MUNICIPALITY,
  SCREEN_MEDIUM,
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
} from '../../../config/constants';

const HeroContentImage = ({ nodeType, imageField }) => {
  const classNames = c(
    'Hero__content__image', {
      'Hero__content__image--offgrid': nodeType === NODE_TYPE_MUNICIPALITY,
      'Hero__content__image--frontPage': nodeType === NODE_TYPE_FRONT_PAGE,
    },
  );

  return (
    <div className={classNames}>
      <ImageFromField
        field={imageField}
        imageStyles={Immutable.Map({
          [SCREEN_MOBILE]: 'crop_hero_xs',
          [SCREEN_MEDIUM]: 'crop_hero_sm',
          [SCREEN_TABLET]: 'crop_hero_md',
          [SCREEN_NORMAL]: 'crop_hero_lg',
        })}
      />
    </div>
  );
};

export default HeroContentImage;
